import { render, staticRenderFns } from "./task_step_plan_task.vue?vue&type=template&id=4bb708e1&scoped=true"
import script from "./task_step_plan_task.vue?vue&type=script&lang=js"
export * from "./task_step_plan_task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb708e1",
  null
  
)

export default component.exports